import { render, staticRenderFns } from "./BoothCard.vue?vue&type=template&id=357b8cde&scoped=true&"
import script from "./BoothCard.vue?vue&type=script&lang=js&"
export * from "./BoothCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357b8cde",
  null
  
)

export default component.exports